/** biome-ignore-all lint/style/useNamingConvention: allow snake case */
import {DateObjectUnits} from 'luxon';
import * as moment from 'moment-timezone';

const createTimezoneObject = (timezoneId: string): Timezone => {
  const momentTz = moment.tz(timezoneId);
  const utcOffset = momentTz.format('Z');
  const gmtOffset = utcOffset.replace('+', '+').replace('-', '-'); // Ensure proper formatting
  const readableName = timezoneId.split('/').pop()?.replace(/_/g, ' ') || timezoneId;

  return {
    timezone_id: timezoneId,
    timezone_display_name: `(GMT${gmtOffset}) ${readableName}`,
    timezone_abbr: momentTz.format('z'),
    utc_offset: utcOffset,
  };
};

const getTimezones = (): Timezone[] => {
  return moment.tz.names().map(createTimezoneObject);
};

const zones = getTimezones();

const selectable = (zone: Timezone): TimezoneOption => ({
  id: zone.timezone_id,
  label: zone.timezone_display_name,
  value: zone.timezone_abbr,
});

export const defaultTimezones = zones.map(selectable);

export const getDefaultTimezones = (): TimezoneOption[] => {
  const zones = getTimezones();
  return zones.map(selectable);
};

export const findTimezoneObject = (tzName: string) => {
  const zones = getTimezones();
  return zones.find((tz) => tz.timezone_id === tzName);
};

export const DEFAULT_TIME_CONFIG: DateObjectUnits = {
  hour: 18,
  minute: 0,
  second: 0,
  millisecond: 0,
};
